import { render, staticRenderFns } from "./SettingsTrainConfigurations.vue?vue&type=template&id=67ca44ab&scoped=true"
import script from "./SettingsTrainConfigurations.vue?vue&type=script&lang=js"
export * from "./SettingsTrainConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca44ab",
  null
  
)

export default component.exports